import postcss from 'postcss'
import type { CssRoot, CssNode } from './types'
import type { CssFile } from '../../../types'
import { getSpxPreambleLayer, transformSpxValue } from './spxTransformer'

const createContainer = (node: CssNode): postcss.Rule | postcss.AtRule => {
    switch (node.type) {
        case 'rule':
            return postcss.rule({ selector: node.selector })
        case 'at-rule':
            return postcss.atRule({ name: node.name, params: node.params })
        default:
            throw new Error(`Unsupported CSS node type: ${(node as any).type}`)
    }
}

const createCssNode = (node: CssNode): postcss.Node => {
    if (node.type === 'declaration') {
        return postcss.decl({ prop: node.prop, value: transformSpxValue(node.value) })
    }

    const container = createContainer(node)
    for (const noade of node.nodes) {
        container.append(createCssNode(noade))
    }

    return container
}

export const generateCssFile = (cssRoot: CssRoot): CssFile => {
    if (cssRoot.nodes.length === 0) {
        return { type: 'css', content: '' }
    }

    const root = postcss.root()

    for (const node of cssRoot.nodes) {
        root.append(createCssNode(node))
    }

    const content = `${getSpxPreambleLayer()}\n\n${root.toString()}`

    return { type: 'css', content }
}
